export default __webpack_public_path__ + "static/media/Roboto-Bold.17451a4c.ttf";